import CustomerDetailPage from './customer-detail-page'

export default CustomerDetailPage